module.exports = __webpack_public_path__ + "static/media/slack.161ee93b.svg";